/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { ResubmitEncounterErrorResponse, ResubmitEncounterResponse } from './api.schemas';

import { api } from '../util/http';

export const resubmitEncounter = (encounterId: number, signal?: AbortSignal) => {
  return api<ResubmitEncounterResponse>({
    url: `/api/encounters/${encounterId}/resubmit`,
    method: 'POST',
    signal,
  });
};

export const getResubmitEncounterMutationOptions = <
  TError = ResubmitEncounterErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resubmitEncounter>>,
    TError,
    { encounterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resubmitEncounter>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationKey = ['resubmitEncounter'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resubmitEncounter>>,
    { encounterId: number }
  > = (props) => {
    const { encounterId } = props ?? {};

    return resubmitEncounter(encounterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResubmitEncounterMutationResult = NonNullable<
  Awaited<ReturnType<typeof resubmitEncounter>>
>;

export type ResubmitEncounterMutationError = ResubmitEncounterErrorResponse;

export const useResubmitEncounter = <TError = ResubmitEncounterErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resubmitEncounter>>,
      TError,
      { encounterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resubmitEncounter>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationOptions = getResubmitEncounterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
